import { FormLabel, Grid } from '@mui/material';
import { useLangFile } from '../../../../../../js/context/LanguageContext';
import { TrackedTextFormControl } from '../../../../Analytics/TrackedComponents';
import { ANALYTICS_EVENTS } from '../../../../Analytics/AnalyticsConstants';
import React, { memo } from 'react';

interface SeedingCalcNonHybridInputsProps {
  TGW: number;
  handleOnUpdateTGW: (tgw: number) => void;
  germinationPercentage: number;
  handleOnUpdateGerminationPercentage: (germinationPercentage: number) => void;
}

const SeedingCalcNonHybridInputs: React.FC<SeedingCalcNonHybridInputsProps> = ({
  TGW,
  handleOnUpdateGerminationPercentage,
  germinationPercentage,
  handleOnUpdateTGW,
}: SeedingCalcNonHybridInputsProps) => {
  const LangFile = useLangFile();

  return (
    <Grid size={5} container spacing={1}>
      <Grid size={6}>
        <FormLabel component="label">{LangFile.PrescriptionSettings.seedingCalc.TGW}</FormLabel>
        <TrackedTextFormControl
          data-testid="seeding-tgw"
          {...ANALYTICS_EVENTS.textField('seeding_calculator_tgw')}
          value={TGW}
          type={'number'}
          disablePadding={true}
          min={0}
          onUpdate={handleOnUpdateTGW}
          endAdornment={'g'}
          acceptZero={true}
          margin="dense"
        />
      </Grid>

      <Grid size={6}>
        <FormLabel component="label">
          {LangFile.PrescriptionSettings.seedingCalc.germinationPercentage.title}
        </FormLabel>
        <TrackedTextFormControl
          data-testid="seeding-germination"
          {...ANALYTICS_EVENTS.textField('seeding_calculator_germination_percentage')}
          acceptZero={true}
          disablePadding={true}
          value={germinationPercentage}
          min={50}
          max={100}
          type={'number'}
          endAdornment={'%'}
          onUpdate={handleOnUpdateGerminationPercentage}
          margin="dense"
        />
      </Grid>
    </Grid>
  );
};

export default memo(SeedingCalcNonHybridInputs);
